import AuthenticationRoutes from "./authentication";
import BlankLayout from "@layouts/types/blank-layout";
import { Fragment } from "react";
import LayoutWrapper  from "@layouts/components/layout-wrapper";
import PanelRoutes from "./panel";
import PrivateRoute from "../private-route";
import PublicRoute from "../public-route";
import VerticalLayout from "@layouts/types/vertical-layout";
import size from "lodash/size";

export const SuperAdminDefaultRoute = "/superadmin/organizations";

// ** Panel Default Route
export const PanelDefaultRoute = "/platforms";

// ** Merge Routes
const Routes = [
    ...AuthenticationRoutes,
    ...PanelRoutes
];

const getRouteMeta = (route) => {
    if (!size(route.element.props)) {
        if (route.meta) {
            return { routeMeta: route.meta };
        } else {
            return {};
        }
    }
};

// ** Return Filtered Array of Routes & Paths
const MergeLayoutRoutes = (layout, defaultLayout) => {
    const LayoutRoutes = [];

    if (Routes) {
        Routes.filter((route) => {
            let isBlank = false;
            // ** Checks if Route layout or Default layout matches current layout
            if (
                (route.meta && route.meta.layout && route.meta.layout === layout) ||
        ((route.meta === undefined || route.meta.layout === undefined) &&
          defaultLayout === layout)
            ) {
                let RouteTag = PrivateRoute;
                // ** Check for public or private route
                if (route.meta) {
                    route.meta.layout === "blank" ? (isBlank = true) : (isBlank = false);
                    RouteTag = route.meta.publicRoute ? PublicRoute : PrivateRoute;
                }
                if (route.element) {
                    const Wrapper =
                    // eslint-disable-next-line multiline-ternary
                    !size(route.element.props) && isBlank === false
                        ? // eslint-disable-next-line multiline-ternary
                        LayoutWrapper
                        : Fragment;
                    route.element = (
                        <Wrapper {...(isBlank === false ? getRouteMeta(route) : {})}>
                            <RouteTag route={route}>{route.element}</RouteTag>
                        </Wrapper>
                    );
                }
                // Push route to LayoutRoutes
                LayoutRoutes.push(route);
            }
            return LayoutRoutes;
        });
    }
    return LayoutRoutes;
};
const getLayout = {
    blank   : <BlankLayout />,
    vertical: <VerticalLayout routes={Routes} />
};

const getRoutes = () => {
    const defaultLayout = "vertical";
    const layouts = ["vertical", "blank"];
    const AllRoutes = [];
   
    layouts.forEach((layoutItem) => {
        const LayoutRoutes = MergeLayoutRoutes(layoutItem, defaultLayout);
        AllRoutes.push({
            path    : "/",
            element : getLayout[layoutItem] || getLayout[defaultLayout],
            children: LayoutRoutes
        });
    });
    return AllRoutes;
};

export { Routes, getRoutes };
